import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceUp2.vue?vue&type=template&id=1eb73154&"
import script from "./FaceDirectionResultEffectFaceUp2.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceUp2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports